export const PROFILE_AVATARS = [
  '/profile/anime-away-face-svgrepo-com.svg',
  '/profile/avatar-boy-svgrepo-com.svg',
  '/profile/foxgrin-svgrepo-com.svg',
  '/profile/male-avatar-svgrepo-com.svg',
  '/profile/man-with-two-swords-svgrepo-com.svg',
  '/profile/monster-heart-svgrepo-com.svg',
  '/profile/nerd-face-svgrepo-com.svg',
  '/profile/ninja-head-svgrepo-com.svg',
  '/profile/operator-avatar-svgrepo-com.svg',
];

/**
 * Deterministically pick an avatar based on a string identifier (e.g. user ID or email)
 */
export function getAvatarForUser(identifier: string | undefined): string {
  if (!identifier) return PROFILE_AVATARS[0];
  
  // Simple hash function for the string
  let hash = 0;
  for (let i = 0; i < identifier.length; i++) {
    hash = identifier.charCodeAt(i) + ((hash << 5) - hash);
  }
  
  // Get positive index
  const index = Math.abs(hash) % PROFILE_AVATARS.length;
  return PROFILE_AVATARS[index];
}
